require('ub_legacy/lp/editor/invariants/invariants-helper.js');
require('ub_legacy/lp/invariants.js');
require('ub_legacy/lp/editor/editor-element-listeners.js');
require('ub_legacy/lp/editor/editor.js');
require('ub_legacy/lp/editor/parallax_fixer.js');
require('ub_legacy/lp/editor/tree_toggler.js');
require('ub_legacy/lp/editor/dnd/dnd.js');
require('ub_legacy/lp/editor/element_pallet_dnd.js');
require('ub_legacy/lp/editor/builder_modal.js');
require('ub_legacy/lp/editor/action_hint_bar.js');
require('ub_legacy/lp/editor/basic_dialog.js');
require('ub_legacy/lp/editor/content_panel.js');
require('ub_legacy/lp/editor/info_panel.js');
require('ub_legacy/lp/editor/component_side_bar.js');
require('ub_legacy/lp/editor/non_visible_elements_shelf.js');
require('ub_legacy/lp/editor/save_template_dialog.js');
require('ub_legacy/lp/editor/key_controller.js');
require('ub_legacy/lp/editor/page_element_tree.js');
require('ub_legacy/lp/editor/snap_manager.js');
require('ub_legacy/lp/editor/color_overlay_element.js');
require('ub_legacy/lp/editor/dynamic_text_dialog.js');
require('ub_legacy/lp/editor/dynamic_text_upsell_dialog.js');
require('ub_legacy/lp/editor/section_transform_box.js');
require('ub_legacy/lp/editor/element_boundary_control.js');
require('ub_legacy/lp/editor/page_boundary_manager.js');
require('ub_legacy/lp/editor/section_boundary_manager.js');
require('ub_legacy/lp/editor/transform_box.js');
require('ub_legacy/lp/editor/selection_box.js');
require('ub_legacy/lp/editor/image_transform_box.js');
require('ub_legacy/lp/editor/image_transform_box_handle.js');
require('ub_legacy/lp/editor/offset_indicators.js');
require('ub_legacy/lp/editor/transform_box_handle.js');
require('ub_legacy/lp/editor/transform_box_handle_helper.js');
require('ub_legacy/lp/editor/section_transform_box_handle_helper.js');
require('ub_legacy/lp/editor/text_transform_box_handle_helper.js');
require('ub_legacy/lp/editor/transform_box_boundary.js');
require('ub_legacy/lp/editor/container_hilite.js');
require('ub_legacy/lp/editor/element_hilite.js');
require('ub_legacy/lp/editor/panel/element_properties_panel.js');
require('ub_legacy/lp/editor/panel/element_geometry_controls.js');

require('ub_legacy/lp/editor/panel/element_background_controls_flat.js');
require('ub_legacy/lp/editor/panel/element_background_controls_old.js');

require('ub_legacy/lp/editor/panel/element_border_controls.js');
require('ub_legacy/lp/editor/panel/autolayout-properties-panel.js');
require('ub_legacy/lp/editor/flash_box.js');
require('ub_legacy/lp/editor/element_protrusion_detection.js');
require('ub_legacy/lp/editor/page_section_protrusion.js');
require('ub_legacy/lp/editor/element_reparenting_tooltip.js');
require('ub_legacy/lp/editor/form_element_manager.js');
require('ub_legacy/lp/editor/element_visibility_manager.js');

require('ub_legacy/lp/new-feature-tour-config.js');
require('ub_legacy/lp/viewport-positioning.js');

require('ub_legacy/lp/breakpoint-change-notice.js');

require('ub_legacy/lp/editor/performance/perf_sampling.js');
require('ub_legacy/lp/editor/performance/perf_breakpoint_changed.js');
require('ub_legacy/lp/editor/performance/perf_page_changed.js');
require('ub_legacy/lp/editor/performance/perf_send_to_sns.js');

require('ub_legacy/lp/editor/invariants/advanced-properties-panel-invariants.js');
require('ub_legacy/lp/editor/invariants/background-panel-invariants.js');
require('ub_legacy/lp/editor/invariants/content-tree-invariants.js');
require('ub_legacy/lp/editor/invariants/core-invariants.js');
require('ub_legacy/lp/editor/invariants/form-invariants.js');
require('ub_legacy/lp/editor/invariants/transform-box-invariants.js');
require('ub_legacy/lp/editor/invariants/new_background_properties_invariants.js');

require('ub_legacy/lp/editor/event_tracking/external_event_tracking.js');

require('ub/lp/editor/toolbar/primary-header-toolbar.js');
require('ub/lp/editor/add-amp-lightbox.js');



// WEBPACK FOOTER //
// ./src/lp-editor.js